"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/spwn/v1/portal_service.proto (package spwn.spwn.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpwnService = void 0;
const portal_service_pb_1 = require("./portal_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.spwn.v1.SpwnService
 */
exports.SpwnService = {
    typeName: "spwn.spwn.v1.SpwnService",
    methods: {
        /**
         * PAWの残高を取得する
         *
         * @generated from rpc spwn.spwn.v1.SpwnService.FetchPawBalance
         */
        fetchPawBalance: {
            name: "FetchPawBalance",
            I: portal_service_pb_1.SpwnServiceFetchPawBalanceRequest,
            O: portal_service_pb_1.SpwnServiceFetchPawBalanceResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * PAWのチャージ履歴を取得する
         *
         * @generated from rpc spwn.spwn.v1.SpwnService.FetchPawChargeHistory
         */
        fetchPawChargeHistory: {
            name: "FetchPawChargeHistory",
            I: portal_service_pb_1.SpwnServiceFetchPawChargeHistoryRequest,
            O: portal_service_pb_1.SpwnServiceFetchPawChargeHistoryResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * PAWの使用履歴を取得する
         *
         * @generated from rpc spwn.spwn.v1.SpwnService.FetchPawUsageHistory
         */
        fetchPawUsageHistory: {
            name: "FetchPawUsageHistory",
            I: portal_service_pb_1.SpwnServiceFetchPawUsageHistoryRequest,
            O: portal_service_pb_1.SpwnServiceFetchPawUsageHistoryResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * 新規クレジットカードでPAWをチャージする
         *
         * @generated from rpc spwn.spwn.v1.SpwnService.PurchasePawWithCard
         */
        purchasePawWithCard: {
            name: "PurchasePawWithCard",
            I: portal_service_pb_1.SpwnServicePurchasePawWithCardRequest,
            O: portal_service_pb_1.SpwnServicePurchasePawWithCardResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 新規クレジットカードでPAWをチャージする（3Dセキュア2.0対応版）
         *
         * @generated from rpc spwn.spwn.v1.SpwnService.PurchasePawWithCard3DS
         */
        purchasePawWithCard3DS: {
            name: "PurchasePawWithCard3DS",
            I: portal_service_pb_1.SpwnServicePurchasePawWithCard3DSRequest,
            O: portal_service_pb_1.SpwnServicePurchasePawWithCard3DSResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 登録済みクレジットカードでPAWをチャージする
         *
         * @generated from rpc spwn.spwn.v1.SpwnService.PurchasePawWithMember
         */
        purchasePawWithMember: {
            name: "PurchasePawWithMember",
            I: portal_service_pb_1.SpwnServicePurchasePawWithMemberRequest,
            O: portal_service_pb_1.SpwnServicePurchasePawWithMemberResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 登録済みクレジットカードでPAWをチャージする（3Dセキュア2.0対応版）
         *
         * @generated from rpc spwn.spwn.v1.SpwnService.PurchasePawWithMember3DS
         */
        purchasePawWithMember3DS: {
            name: "PurchasePawWithMember3DS",
            I: portal_service_pb_1.SpwnServicePurchasePawWithMember3DSRequest,
            O: portal_service_pb_1.SpwnServicePurchasePawWithMember3DSResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * PAWを使用する
         *
         * @generated from rpc spwn.spwn.v1.SpwnService.UsePawValue
         */
        usePawValue: {
            name: "UsePawValue",
            I: portal_service_pb_1.SpwnServiceUsePawValueRequest,
            O: portal_service_pb_1.SpwnServiceUsePawValueResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.spwn.v1.SpwnService.SecureTran2
         */
        secureTran2: {
            name: "SecureTran2",
            I: portal_service_pb_1.SpwnServiceSecureTran2Request,
            O: portal_service_pb_1.SpwnServiceSecureTran2Response,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * PAWの購入を完了する (3Dセキュア2.0対応版)
         *
         * @generated from rpc spwn.spwn.v1.SpwnService.CompletePurchasePAWWith3DS
         */
        completePurchasePAWWith3DS: {
            name: "CompletePurchasePAWWith3DS",
            I: portal_service_pb_1.SpwnServiceCompletePurchasePAWWith3DSRequest,
            O: portal_service_pb_1.SpwnServiceCompletePurchasePAWWith3DSResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
    }
};
//# sourceMappingURL=portal_service_connect.js.map